import { css } from 'styled-components';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import { body2 } from '@westwing/ui-kit/typography';

export const mobileSuggestionsContent = css`
    flex-grow: 1;
    border: none;
    width: 100%;
    opacity: 1;
    padding: 23px 20px 220px;
`;

export const desktopSuggestionsContent = forDesktop`
        position: static;
        border: 1px solid ${({ theme }) => theme.colors.charcoal20};
        height: auto;
        max-height: 565px;
        opacity: 1;
        padding: 18px 18px 25px;
`;
export const mobileActiveSearch = css`
    ${body2}
    width: 100%;
    min-height: 52px;
    grid-template-rows: 52px;
    align-items: center;
    padding: 0 13px 0 20px;
    border: none;
    background: ${({ theme }) => theme.colors.colorBackgroundGrey};
`;

export const desktopActiveSearchInput = forDesktop`
        background: ${({ theme }) => theme.colors.white};
`;
